import {Component, ElementRef, OnInit, AfterViewInit, ChangeDetectorRef, TemplateRef, ViewChild} from '@angular/core';

import {ToastrService} from "ngx-toastr";
import {Router} from "@angular/router";
import {NgbModal, NgbModalOptions} from "@ng-bootstrap/ng-bootstrap";
import {HeaderService} from "../../../../services/header/header.service";
import flatpickr from "flatpickr";
import {French} from "flatpickr/dist/l10n/fr";
import * as Feather from 'feather-icons';
import {DataService, Quote} from "../../../../services/commande-client/data.service";
import {TresorerieService} from "../../../../services/tresorerie/tresorerie.service";
import {BanqueService} from "../../../../services/Banque/banque.service";
import {Banque} from "../../../../models/banque.model";
import {forkJoin} from "rxjs";
import {ChequeTraite} from '../../../../models/Tresorerie/ChequeTraite';

@Component({
    selector: 'app-cheque-traites',
    templateUrl: './cheque-traites.component.html',
    styleUrls: ['./cheque-traites.component.scss']
})
export class ChequeTraitesComponent implements OnInit, AfterViewInit {
    @ViewChild('datePicker') datePicker!: ElementRef;


    items: any[] = [];
    isLoading: boolean = false;
    stationId: number = 0;
    selectedItemId: number | null = null;
    
    // Propriétés pour le filtrage de date (utilisées pour le filtrage côté client)
    dateFilterStart: string = '';
    dateFilterEnd: string = '';

    archiveData: Quote[] = [];
    filteredData: any[] = [];
    paginatedData: Quote[] = [];
    searchTerm = '';
    showFilter = false;
    banquesMap: { [key: number]: string } = {};
    banques: Banque[] = [];
    private _activeFilters: Array<{key: string, label: string, value: string}> = [];


    basicSelectedOption = 10;
    currentPage = 1;
    totalPages = 1;
    pages: number[] = [];
    filterSummary = '';
    totalItems = 0; // Total d'éléments depuis l'API

    perPage = 5;
    pageOptions = [5, 10, 20];
    statuses = ['Tous', 'Brouillon', 'Créé', 'Annulé', 'Négociation', 'Accepté'];

    filters: any = {
        type_operation: '', // 'emis' ou 'recu'
        type_paiement: '', // 'cheque' ou 'traite'
        banque_id: null,
        dateFrom: '', // Date d'échéance début
        dateTo: '', // Date d'échéance fin
        statut: '' // État
    };

    constructor(
        private toastr: ToastrService,
        private dataService: DataService,
        private router: Router,
        private modalService: NgbModal,
        private headerService: HeaderService,
        private tresorerieService: TresorerieService,
        private banqueService: BanqueService,
        private cd: ChangeDetectorRef
    ) {
    }

    ngOnInit() {
        this.headerService.setConfig({
            title: 'Cheque et traite',
            buttons: [
                {
                    label: 'Exporter',
                   // action: () => this.exportData(),
                    type: 'secondary'
                }
            ]
        });

        // Ne pas initialiser les dates de filtre - toutes les données seront affichées par défaut
        this.dateFilterStart = '';
        this.dateFilterEnd = '';

        this.loadUserData();
        setTimeout(() => {
            if (this.stationId) {
                forkJoin({
                    banques: this.banqueService.getBanques(this.stationId),
                    chequesTraites: this.tresorerieService.getChequesTraites(this.buildApiFilters())
                }).subscribe({
                    next: (results) => {
                        this.processBanques(results.banques);
                        this.processChequesTraites(results.chequesTraites);
                        this.getActiveFilters();
                    },
                    error: (error) => {
                        console.error('❌ [ChequeTraitesComponent] Erreur lors du chargement:', error);
                        this.isLoading = false;
                        this.toastr.error('Erreur lors du chargement des données', 'Erreur');
                    }
                });
            } else {
                this.loadChequesTraites();
            }
        }, 100);
    }

    private loadUserData(): void {
        try {
            const userJson = localStorage.getItem('currentUser');
            if (userJson) {
                const user = JSON.parse(userJson);
                const station = user?.stations?.[0];
                this.stationId = station?.id ? Number(station.id) : 0;
                console.log('📋 [ChequeTraitesComponent] Données utilisateur chargées:', {
                    userId: user?.id,
                    stationId: this.stationId
                });
            } else {
                console.warn('⚠️ [ChequeTraitesComponent] Aucune donnée utilisateur trouvée');
            }
        } catch (error) {
            console.error('❌ [ChequeTraitesComponent] Erreur lors de la récupération des données utilisateur:', error);
        }
    }

    private processBanques(response: any): void {
        console.log('🏦 [ChequeTraitesComponent] Réponse API banques:', response);
        let banques: Banque[] = [];
        if (response && response.banques && Array.isArray(response.banques)) {
            banques = response.banques;
        } else if (response && response.data && Array.isArray(response.data)) {
            banques = response.data;
        } else if (Array.isArray(response)) {
            banques = response;
        }
        this.banques = banques;
        this.banquesMap = {};
        banques.forEach(banque => {
            if (banque.id && banque.nom) {
                this.banquesMap[banque.id] = banque.nom;
            }
        });

        console.log('✅ [ChequeTraitesComponent] Banques chargées:', Object.keys(this.banquesMap).length);
    }

    /**
     * Convertit le statut du backend en format d'affichage
     * @param statut Statut depuis le backend (ex: 'en_cours')
     * @returns Statut formaté pour l'affichage (ex: 'En cours')
     */
    private formatStatut(statut: string | null | undefined): string {
        if (!statut) return 'En cours';
        
        // Convertir les underscores en espaces et mettre en forme
        const statutMap: { [key: string]: string } = {
            'en_cours': 'En cours',
            'en_attente': 'En attente',
            'valide': 'Validé',
            'annule': 'Annulé',
            'annulee': 'Annulée',
            'payé': 'Payé',
            'paye': 'Payé',
            'non_payé': 'Non payé',
            'non_paye': 'Non payé'
        };
        
        return statutMap[statut.toLowerCase()] || statut.replace(/_/g, ' ').replace(/\b\w/g, (l) => l.toUpperCase());
    }

    private processChequesTraites(response: any): void {
        this.isLoading = false;
        console.log('📦 [ChequeTraitesComponent] Réponse API complète:', response);
        let chequesTraites: any[] = [];
        
        // Extraire les informations de pagination de l'API
        if (response && response.success && response.data && response.data.pagination) {
            const pagination = response.data.pagination;
            this.totalItems = pagination.total || 0;
            this.totalPages = pagination.pages || 1;
            this.currentPage = pagination.page || 1;
            console.log(`📄 [ChequeTraitesComponent] Pagination API: ${this.currentPage}/${this.totalPages}, Total: ${this.totalItems}`);
        }
        
        if (response && response.success && response.data && response.data.cheques_traites && Array.isArray(response.data.cheques_traites)) {
            chequesTraites = response.data.cheques_traites;
            console.log('✅ [ChequeTraitesComponent] Données extraites depuis data.cheques_traites:', chequesTraites.length);
        }
        else if (response && response.data && Array.isArray(response.data)) {
            chequesTraites = response.data;
            console.log('✅ [ChequeTraitesComponent] Données extraites depuis data:', chequesTraites.length);
        }
        else if (Array.isArray(response)) {
            chequesTraites = response;
            console.log('✅ [ChequeTraitesComponent] Données extraites depuis response:', chequesTraites.length);
        } else {
            console.warn('⚠️ [ChequeTraitesComponent] Structure de réponse non reconnue:', response);
        }
        this.items = chequesTraites.map(item => {
            const clientName = item.client && Array.isArray(item.client) && item.client.length > 0 
                ? item.client[0].nom_client 
                : (item.client_id || '--');
            const typePaiement = item.type || item.type_paiement || 'cheque';
            const typeLabel = typePaiement === 'cheque' ? 'Chèque' : 'Traite';
            const banqueId = item.banque_id;
            const banqueName = banqueId && this.banquesMap[banqueId] 
                ? this.banquesMap[banqueId] 
                : (banqueId ? `Banque #${banqueId}` : '--');
            
            return {
                id: item.id,
                type: typeLabel,
                numero: item.numero_cheque || item.numero_traite || '--',
                contact: clientName,
                porteur: item.porteur || '--',
                banque: banqueName,
                banque_id: banqueId, // Stocker l'ID pour le filtrage
                date_paiement: item.date_paiement ? this.formatDate(item.date_paiement) : (item.date_reglement ? this.formatDate(item.date_reglement) : '--'),
                date_echeance: item.date_echeance ? this.formatDate(item.date_echeance) : '--',
                date_paiement_raw: item.date_paiement || item.date_reglement || null, // Stocker la date brute pour le filtrage
                date_echeance_raw: item.date_echeance || null, // Stocker la date brute pour le filtrage
                montant: parseFloat(item.montant || 0).toFixed(3) + ' TND',
                etat: this.formatStatut(item.statut), // Convertir le statut pour l'affichage
                statut_raw: item.statut || 'en_cours', // Stocker le statut brut pour la modification
                type_operation: item.type_operation,
                type_paiement: typePaiement,
                solde_type: item.solde_type,
                depuis: item.depuis || null // Stocker l'attribut depuis pour conditionner l'affichage de la suppression
            };
        });

        // Trier les items par ID décroissant (les plus récents en premier)
        this.items.sort((a, b) => {
            const idA = a.id || 0;
            const idB = b.id || 0;
            return idB - idA; // Ordre décroissant
        });

        console.log('📊 [ChequeTraitesComponent] Items transformés et triés par ID décroissant:', this.items.length);
        if (this.items.length > 0) {
            console.log('📊 [ChequeTraitesComponent] Premier item:', this.items[0]);
        }
        
        // Mettre à jour la pagination avec les données de l'API
        this.updatePaginationFromAPI();
        this.getActiveFilters();
        this.updateFilteredData();
    }

    private loadChequesTraites(filters?: any): void {
        if (!this.stationId) {
            console.warn('⚠️ [ChequeTraitesComponent] Station ID non disponible');
            return;
        }

        this.isLoading = true;
        const apiFilters = filters || this.buildApiFilters();
        this.tresorerieService.getChequesTraites(apiFilters).subscribe({
            next: (response) => {
                this.processChequesTraites(response);
            },
            error: (error) => {
                this.isLoading = false;
                console.error('❌ [ChequeTraitesComponent] Erreur lors du chargement:', error);
                this.toastr.error('Erreur lors du chargement des données', 'Erreur');
            }
        });
    }

    private buildApiFilters(): any {
        const apiFilters: any = {
            station_id: this.stationId,
            page: this.currentPage,
            limit: this.basicSelectedOption
        };
        if (this.filters.type_operation) {
            apiFilters.type_operation = this.filters.type_operation;
        }
        if (this.filters.type_paiement) {
            apiFilters.type_paiement = this.filters.type_paiement;
        }
        // Note: Les dates dateFrom et dateTo sont maintenant filtrées côté client
        // On ne les envoie plus à l'API pour garantir qu'on filtre toujours sur toutes les données

        return apiFilters;
    }

    formatDate(dateString: string): string {
        if (!dateString) return '--';
        const date = new Date(dateString);
        return date.toLocaleDateString('fr-FR');
    }

    ngAfterViewInit() {
        setTimeout(() => {
            Feather.replace();
        }, 0);
    }

    /**
     * Parse une date au format "DD / MM / YYYY" ou autres formats
     */
    private parseDate(dateStr: string | Date): Date | null {
        if (!dateStr) return null;
        
        if (dateStr instanceof Date) {
            return isNaN(dateStr.getTime()) ? null : dateStr;
        }
        
        const dateString = String(dateStr).trim();
        if (!dateString) return null;
        
        // Format "DD / MM / YYYY" avec espaces
        const match1 = dateString.match(/(\d{1,2})\s*\/\s*(\d{1,2})\s*\/\s*(\d{4})/);
        if (match1) {
            const day = parseInt(match1[1], 10);
            const month = parseInt(match1[2], 10) - 1;
            const year = parseInt(match1[3], 10);
            const date = new Date(year, month, day);
            if (!isNaN(date.getTime())) {
                return date;
            }
        }
        
        // Format ISO "YYYY-MM-DD"
        const isoMatch = dateString.match(/^(\d{4})-(\d{2})-(\d{2})/);
        if (isoMatch) {
            const year = parseInt(isoMatch[1], 10);
            const month = parseInt(isoMatch[2], 10) - 1;
            const day = parseInt(isoMatch[3], 10);
            const date = new Date(year, month, day);
            if (!isNaN(date.getTime())) {
                return date;
            }
        }
        
        const parsed = new Date(dateString);
        if (!isNaN(parsed.getTime())) {
            return parsed;
        }
        
        return null;
    }

    /**
     * Applique le filtre de date - recharge toutes les données puis filtre côté client
     */
    private applyDateFilter(startDate: string, endDate: string): void {
        console.log(`🔄 [applyDateFilter] Application du filtre de date: ${startDate} - ${endDate}`);
        
        // Mettre à jour les dates de filtre
        this.dateFilterStart = startDate;
        this.dateFilterEnd = endDate;
        
        // Recharger toutes les données (sans filtre de date côté API)
        // Le filtrage de date se fera côté client dans updateFilteredData
        this.loadChequesTraites();
    }

    /**
     * Écoute les changements de date depuis le composant app-filtre-date
     */
    onDateFilterChange(event: {startDate: string, endDate: string}): void {
        console.log(`🔄 [onDateFilterChange] Changement de date depuis app-filtre-date: ${event.startDate} - ${event.endDate}`);
        this.applyDateFilter(event.startDate, event.endDate);
    }

    toggleFilter() {
        this.showFilter = !this.showFilter;

    }

    onSearch() {
        this.updateFilteredData();
    }


    trackByFilterKey(index: number, filter: {key: string, label: string, value: string}): string {
        return filter.key;
    }

    get activeFilters(): Array<{key: string, label: string, value: string}> {
        return this._activeFilters;
    }

    getActiveFilters(): Array<{key: string, label: string, value: string}> {
        const activeFilters: Array<{key: string, label: string, value: string}> = [];
        
        if (this.filters.type_operation) {
            const typeLabel = this.filters.type_operation === 'emis' ? 'Émis' : 'Reçu';
            activeFilters.push({
                key: 'type_operation',
                label: "Type d'opération",
                value: typeLabel
            });
        }
        
        if (this.filters.type_paiement) {
            const paiementLabel = this.filters.type_paiement === 'cheque' ? 'Chèque' : 'Traite';
            activeFilters.push({
                key: 'type_paiement',
                label: 'Type de paiement',
                value: paiementLabel
            });
        }
        
        if (this.filters.banque_id !== null && this.filters.banque_id !== undefined) {
            const banqueName = this.banquesMap[this.filters.banque_id] || `Banque #${this.filters.banque_id}`;
            activeFilters.push({
                key: 'banque_id',
                label: 'Banque',
                value: banqueName
            });
        }
        
        // Ne pas afficher le filtre de date dans les boutons de filtres actifs
        // Le filtre de date est géré par le composant app-filtre-date
        
        if (this.filters.statut) {
            activeFilters.push({
                key: 'statut',
                label: 'État',
                value: this.filters.statut
            });
        }
        this._activeFilters = activeFilters;
        return activeFilters;
    }

    removeFilter(filterKey: string): void {
        if (filterKey === 'type_operation') {
            this.filters.type_operation = '';
        } else if (filterKey === 'type_paiement') {
            this.filters.type_paiement = '';
        } else if (filterKey === 'banque_id') {
            this.filters.banque_id = null;
        } else if (filterKey === 'dateFrom') {
            this.filters.dateFrom = '';
        } else if (filterKey === 'dateTo') {
            this.filters.dateTo = '';
        } else if (filterKey === 'date_echeance') {
            // Réinitialiser le filtre de date - afficher toutes les données
            this.dateFilterStart = '';
            this.dateFilterEnd = '';
        } else if (filterKey === 'statut') {
            this.filters.statut = '';
        }

        this.getActiveFilters();
        this.updateFilteredData();
        this.cd.detectChanges();
        this.loadChequesTraites();
        setTimeout(() => {
            Feather.replace();
        }, 100);
    }

    updateFilterSummary() {
        const activeFilters: string[] = [];
        if (this.filters.type_operation) {
            const typeLabel = this.filters.type_operation === 'emis' ? 'Émis' : 'Reçu';
            activeFilters.push(`Type d'opération: ${typeLabel}`);
        }
        if (this.filters.type_paiement) {
            const paiementLabel = this.filters.type_paiement === 'cheque' ? 'Chèque' : 'Traite';
            activeFilters.push(`Type de paiement: ${paiementLabel}`);
        }
        if (this.filters.dateFrom) activeFilters.push(`Date d'échéance depuis: ${this.filters.dateFrom}`);
        if (this.filters.dateTo) activeFilters.push(`Date d'échéance jusqu'à: ${this.filters.dateTo}`);
        if (this.filters.statut) activeFilters.push(`État: ${this.filters.statut}`);

        this.filterSummary = activeFilters.join(', ');
    }

    resetFilters() {
        this.filters = {
            type_operation: '',
            type_paiement: '',
            banque_id: null,
            dateFrom: '',
            dateTo: '',
            statut: ''
        };
        this.searchTerm = '';
        // Réinitialiser aussi les filtres de date - afficher toutes les données
        this.dateFilterStart = '';
        this.dateFilterEnd = '';
        this.loadChequesTraites();
        this.toggleFilter();
        setTimeout(() => {
            Feather.replace();
        }, 100);
    }

    applyFilters() {
        this.getActiveFilters();
        this.loadChequesTraites();
        this.toggleFilter();
        setTimeout(() => {
            Feather.replace();
        }, 100);
    }

    updateFilteredData() {
        let filtered = this.items.filter(item => {
            const matchesSearch = !this.searchTerm || 
                (item.type?.toLowerCase().includes(this.searchTerm.toLowerCase()) || '') ||
                (item.numero?.toLowerCase().includes(this.searchTerm.toLowerCase()) || '') ||
                (item.porteur?.toLowerCase().includes(this.searchTerm.toLowerCase()) || '') ||
                (item.contact?.toLowerCase().includes(this.searchTerm.toLowerCase()) || '') ||
                (item.banque?.toLowerCase().includes(this.searchTerm.toLowerCase()) || '');
            const matchesBanque = !this.filters.banque_id || item.banque_id === this.filters.banque_id;

            // Filtrage par date_paiement ET date_echeance (l'item est inclus si au moins une des deux dates est dans la plage)
            const matchesDate = (() => {
                if (!this.dateFilterStart && !this.dateFilterEnd) return true;
                
                // Fonction helper pour vérifier si une date est dans la plage
                const isDateInRange = (dateStr: string | null | undefined): boolean => {
                    if (!dateStr || dateStr === '--') return false;
                    
                    const itemDate = this.parseDate(dateStr);
                    if (!itemDate || isNaN(itemDate.getTime())) {
                        return false;
                    }
                    
                    let matches = true;
                    
                    if (this.dateFilterStart) {
                        const dateStart = this.parseDate(this.dateFilterStart);
                        if (dateStart) {
                            dateStart.setHours(0, 0, 0, 0);
                            const itemDateStart = new Date(itemDate);
                            itemDateStart.setHours(0, 0, 0, 0);
                            if (itemDateStart < dateStart) matches = false;
                        }
                    }
                    
                    if (this.dateFilterEnd && matches) {
                        const dateEnd = this.parseDate(this.dateFilterEnd);
                        if (dateEnd) {
                            dateEnd.setHours(23, 59, 59, 999);
                            const itemDateEnd = new Date(itemDate);
                            itemDateEnd.setHours(23, 59, 59, 999);
                            if (itemDateEnd > dateEnd) matches = false;
                        }
                    }
                    
                    return matches;
                };
                
                // Vérifier date_paiement
                const datePaiementStr = (item as any).date_paiement_raw;
                const matchesPaiement = isDateInRange(datePaiementStr);
                
                // Vérifier date_echeance
                const dateEcheanceStr = (item as any).date_echeance_raw || item.date_echeance;
                const matchesEcheance = isDateInRange(dateEcheanceStr);
                
                // L'item est inclus si au moins une des deux dates est dans la plage (OU logique)
                return matchesPaiement || matchesEcheance;
            })();

            return matchesSearch && matchesBanque && matchesDate;
        });
        if (this.filters.statut) {
            filtered = filtered.filter(item => item.etat === this.filters.statut);
        }

        this.filteredData = filtered as any[];
        console.log(`🔍 [updateFilteredData] ${this.filteredData.length} élément(s) filtré(s) sur ${this.items.length} total`);
        
        // Note: updatePagination() n'est plus appelé ici car la pagination est gérée par l'API
        // Les données sont déjà paginées par l'API, donc on utilise directement items
        this.paginatedData = this.items;
        this.updateFilterSummary();
    }

    /**
     * Met à jour la pagination avec les données de l'API
     */
    updatePaginationFromAPI(): void {
        this.pages = Array.from({length: this.totalPages}, (_, i) => i + 1);
        // Les données sont déjà paginées par l'API, donc on utilise directement items
        this.paginatedData = this.items;
        console.log(`📄 [updatePaginationFromAPI] Page ${this.currentPage}/${this.totalPages}, ${this.paginatedData.length} élément(s) affiché(s) sur ${this.totalItems} total`);
    }

    /**
     * Met à jour la pagination côté client (pour le filtrage local)
     */
    updatePagination(): void {
        if (!this.basicSelectedOption || this.basicSelectedOption <= 0) {
            this.basicSelectedOption = 10; // Valeur par défaut
        }
        
        this.totalPages = Math.ceil(this.filteredData.length / this.basicSelectedOption) || 1;
        this.currentPage = Math.min(Math.max(this.currentPage, 1), this.totalPages);
        this.pages = Array.from({length: this.totalPages}, (_, i) => i + 1);
        const start = (this.currentPage - 1) * this.basicSelectedOption;
        this.paginatedData = this.filteredData.slice(start, start + this.basicSelectedOption);
        
        console.log(`📄 [updatePagination] Page ${this.currentPage}/${this.totalPages}, ${this.paginatedData.length} élément(s) affiché(s) sur ${this.filteredData.length} total`);
    }

    changePage(page: number) {
        this.currentPage = page;
        // Recharger les données depuis l'API avec la nouvelle page
        this.loadChequesTraites();
    }

    onLimitChange(): void {
        this.currentPage = 1; // Réinitialiser à la première page lors du changement de limite
        this.loadChequesTraites();
    }


    openArchiveModal(content: TemplateRef<any>, itemId?: number) {
        if (itemId) {
            this.selectedItemId = itemId;
        }
        const options: NgbModalOptions = {
            centered: true,
            backdrop: 'static',
            keyboard: true,
        };
        this.modalService.open(content, options);
    }

    getSelectedItemType(): string {
        if (!this.selectedItemId) {
            return 'chèque/traite';
        }
        const item = this.items.find(i => i.id === this.selectedItemId);
        return item?.type || 'chèque/traite';
    }

    confirmDelete(): void {
        if (!this.selectedItemId) {
            this.toastr.error('Aucun élément sélectionné', 'Erreur');
            return;
        }

        this.isLoading = true;
        this.tresorerieService.deleteChequeTraite(this.selectedItemId).subscribe({
            next: (response) => {
                this.isLoading = false;
                if (response.success !== false) {
                    this.toastr.success('Chèque/traite supprimé avec succès', 'Succès');
                    this.modalService.dismissAll();
                    this.loadChequesTraites();
                } else {
                    this.toastr.error(response.message || 'Erreur lors de la suppression', 'Erreur');
                }
            },
            error: (error) => {
                this.isLoading = false;
                const errorMessage = error?.error?.message || 'Erreur lors de la suppression';
                this.toastr.error(errorMessage, 'Erreur');
            }
        });
    }

    /**
     * Alterne le statut d'un chèque/traite au clic sur l'icône dollar
     * Cycle: en_cours -> payé -> non_payé -> payé -> non_payé...
     */
    toggleStatut(item: any): void {
        if (!item || !item.id) {
            this.toastr.error('Données invalides', 'Erreur');
            return;
        }

        // Déterminer le prochain statut selon le cycle
        let nextStatut: string;
        const currentStatut = (item.statut_raw || 'en_cours').toLowerCase();
        
        if (currentStatut === 'en_cours') {
            nextStatut = 'payé';
        } else if (currentStatut === 'payé' || currentStatut === 'paye') {
            nextStatut = 'non_payé';
        } else if (currentStatut === 'non_payé' || currentStatut === 'non_paye') {
            nextStatut = 'payé';
        } else {
            // Si le statut n'est pas reconnu, passer à "payé"
            nextStatut = 'payé';
        }

        // Mettre à jour le statut via l'API
        this.tresorerieService.updateChequeTraiteStatut(item.id, nextStatut).subscribe({
            next: (response) => {
                if (response?.success === true) {
                    // Mettre à jour le statut dans l'item local
                    item.statut_raw = response.data?.statut || nextStatut;
                    item.etat = this.formatStatut(item.statut_raw);
                    
                    // Mettre à jour aussi dans filteredData si présent
                    const filteredItem = this.filteredData.find(f => f.id === item.id);
                    if (filteredItem) {
                        filteredItem.statut_raw = item.statut_raw;
                        filteredItem.etat = item.etat;
                    }
                    
                    this.toastr.success(`Statut mis à jour: ${this.formatStatut(nextStatut)}`, 'Succès');
                    this.cd.detectChanges();
                } else {
                    this.toastr.error(response?.message || 'Erreur lors de la mise à jour du statut', 'Erreur');
                }
            },
            error: (error) => {
                console.error('❌ [ChequeTraitesComponent] Erreur lors de la mise à jour du statut:', error);
                const errorMessage = error?.error?.message || 'Erreur lors de la mise à jour du statut';
                this.toastr.error(errorMessage, 'Erreur');
            }
        });
    }


}
